import React from 'react';
import {connect} from "react-redux";

class AuthenticatedOnly extends React.Component {

    componentDidMount() {
        this.props.onLogin();
    }

    render() {
        return this.props.authenticated ? this.props.children : null;
    }

}

export default connect(
    (state) => {
        return {
            authenticated: state.oidc.authenticated
        }
    },
    (dispatch) => {
        return {
            onLogin: () => {
                dispatch({
                    type: 'LOGIN'
                })
            }
        }
    }
)(AuthenticatedOnly)
